"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftTemplateSection = void 0;
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const react_1 = __importDefault(require("react"));
const shift_context_1 = require("../shift-context");
const ShiftTemplateSection = () => {
    const { formType, templateName, setTemplateName } = (0, shift_context_1.useShift)();
    if (formType !== 'shiftTemplate') {
        return null;
    }
    const errors = templateName.length === 0 || (0, util_1.isUndefined)(templateName)
        ? { hasError: true, errorMessage: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('FORM_ERR_MISSING_REQUIRED')) }
        : {};
    return (react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
        react_1.default.createElement(ui_1.Input, { size: 'full-width', label: (0, util_1.t)('SHIFT_TEMPLATES_NAME'), type: 'text', name: 'template_name', value: templateName, onChange: setTemplateName, ...errors }),
        react_1.default.createElement("div", null)));
};
exports.ShiftTemplateSection = ShiftTemplateSection;
